'use strict';

// Constructor
var Slider = function () {
    $('.slides .links a, .slider button').click(function ($event) {
        $event.preventDefault();
        var $top = $(".slides." + $(this).data('slide')).offset().top ? $(".slides." + $(this).data('slide')).offset().top : 0;
        $("html, body").stop().animate({scrollTop: $top}, 500, 'swing', function () {
            // Waypoint triggers the actions
        });
    });
};

module.exports = Slider;
